export default [
  { value: 'US-AL', name: 'Alabama', info: 'state' },
  { value: 'US-AK', name: 'Alaska', info: 'state' },
  { value: 'US-AZ', name: 'Arizona', info: 'state' },
  { value: 'US-AR', name: 'Arkansas', info: 'state' },
  { value: 'US-CA', name: 'California', info: 'state' },
  { value: 'US-CO', name: 'Colorado', info: 'state' },
  { value: 'US-CT', name: 'Connecticut', info: 'state' },
  { value: 'US-DE', name: 'Delaware', info: 'state' },
  { value: 'US-FL', name: 'Florida', info: 'state' },
  { value: 'US-GA', name: 'Georgia', info: 'state' },
  { value: 'US-HI', name: 'Hawaii', info: 'state' },
  { value: 'US-ID', name: 'Idaho', info: 'state' },
  { value: 'US-IL', name: 'Illinois', info: 'state' },
  { value: 'US-IN', name: 'Indiana', info: 'state' },
  { value: 'US-IA', name: 'Iowa', info: 'state' },
  { value: 'US-KS', name: 'Kansas', info: 'state' },
  { value: 'US-KY', name: 'Kentucky', info: 'state' },
  { value: 'US-LA', name: 'Louisiana', info: 'state' },
  { value: 'US-ME', name: 'Maine', info: 'state' },
  { value: 'US-MD', name: 'Maryland', info: 'state' },
  { value: 'US-MA', name: 'Massachusetts', info: 'state' },
  { value: 'US-MI', name: 'Michigan', info: 'state' },
  { value: 'US-MN', name: 'Minnesota', info: 'state' },
  { value: 'US-MS', name: 'Mississippi', info: 'state' },
  { value: 'US-MO', name: 'Missouri', info: 'state' },
  { value: 'US-MT', name: 'Montana', info: 'state' },
  { value: 'US-NE', name: 'Nebraska', info: 'state' },
  { value: 'US-NV', name: 'Nevada', info: 'state' },
  { value: 'US-NH', name: 'New Hampshire', info: 'state' },
  { value: 'US-NJ', name: 'New Jersey', info: 'state' },
  { value: 'US-NM', name: 'New Mexico', info: 'state' },
  { value: 'US-NY', name: 'New York', info: 'state' },
  { value: 'US-NC', name: 'North Carolina', info: 'state' },
  { value: 'US-ND', name: 'North Dakota', info: 'state' },
  { value: 'US-OH', name: 'Ohio', info: 'state' },
  { value: 'US-OK', name: 'Oklahoma', info: 'state' },
  { value: 'US-OR', name: 'Oregon', info: 'state' },
  { value: 'US-PA', name: 'Pennsylvania', info: 'state' },
  { value: 'US-RI', name: 'Rhode Island', info: 'state' },
  { value: 'US-SC', name: 'South Carolina', info: 'state' },
  { value: 'US-SD', name: 'South Dakota', info: 'state' },
  { value: 'US-TN', name: 'Tennessee', info: 'state' },
  { value: 'US-TX', name: 'Texas', info: 'state' },
  { value: 'US-UT', name: 'Utah', info: 'state' },
  { value: 'US-VT', name: 'Vermont', info: 'state' },
  { value: 'US-VA', name: 'Virginia', info: 'state' },
  { value: 'US-WA', name: 'Washington', info: 'state' },
  { value: 'US-WV', name: 'West Virginia', info: 'state' },
  { value: 'US-WI', name: 'Wisconsin', info: 'state' },
  { value: 'US-WY', name: 'Wyoming', info: 'state' },
  { value: 'US-DC', name: 'District of Columbia', info: 'state' },
  { value: 'US-AS', name: 'American Samoa', info: 'state' },
  { value: 'US-GU', name: 'Guam', info: 'state' },
  { value: 'US-MH', name: 'Marshall Islands', info: 'state' },
  { value: 'US-MP', name: 'Northern Mariana Islands', info: 'state' },
  { value: 'US-PR', name: 'Puerto Rico', info: 'state' },
  { value: 'US-VI', name: 'Virgin Islands of the U.S.', info: 'state' },
  { value: 'AF', name: 'Afghanistan', info: 'country' },
  { value: 'AL', name: 'Albania', info: 'country' },
  { value: 'DZ', name: 'Algeria', info: 'country' },
  { value: 'AD', name: 'Andorra', info: 'country' },
  { value: 'AO', name: 'Angola', info: 'country' },
  { value: 'AI', name: 'Anguilla', info: 'country' },
  { value: 'AQ', name: 'Antarctica', info: 'country' },
  { value: 'AG', name: 'Antigua and Barbuda', info: 'country' },
  { value: 'AR', name: 'Argentina', info: 'country' },
  { value: 'AM', name: 'Armenia', info: 'country' },
  { value: 'AW', name: 'Aruba', info: 'country' },
  { value: 'AU', name: 'Australia', info: 'country' },
  { value: 'AT', name: 'Austria', info: 'country' },
  { value: 'AZ', name: 'Azerbaijan', info: 'country' },
  { value: 'BH', name: 'Bahrain', info: 'country' },
  { value: 'BD', name: 'Bangladesh', info: 'country' },
  { value: 'BB', name: 'Barbados', info: 'country' },
  { value: 'BY', name: 'Belarus', info: 'country' },
  { value: 'BE', name: 'Belgium', info: 'country' },
  { value: 'BZ', name: 'Belize', info: 'country' },
  { value: 'BJ', name: 'Benin', info: 'country' },
  { value: 'BM', name: 'Bermuda', info: 'country' },
  { value: 'BT', name: 'Bhutan', info: 'country' },
  { value: 'BO', name: 'Bolivia', info: 'country' },
  { value: 'BA', name: 'Bosnia and Herzegovina', info: 'country' },
  { value: 'BW', name: 'Botswana', info: 'country' },
  { value: 'BV', name: 'Bouvet Island', info: 'country' },
  { value: 'BR', name: 'Brazil', info: 'country' },
  { value: 'IO', name: 'British Indian Ocean Territory', info: 'country' },
  { value: 'VG', name: 'British Virgin Islands', info: 'country' },
  { value: 'BN', name: 'Brunei', info: 'country' },
  { value: 'BG', name: 'Bulgaria', info: 'country' },
  { value: 'BF', name: 'Burkina Faso', info: 'country' },
  { value: 'BI', name: 'Burundi', info: 'country' },
  { value: 'KH', name: 'Cambodia', info: 'country' },
  { value: 'CM', name: 'Cameroon', info: 'country' },
  { value: 'CA', name: 'Canada', info: 'country' },
  { value: 'CV', name: 'Cape Verde', info: 'country' },
  { value: 'KY', name: 'Cayman Islands', info: 'country' },
  { value: 'CF', name: 'Central African Republic', info: 'country' },
  { value: 'TD', name: 'Chad', info: 'country' },
  { value: 'CL', name: 'Chile', info: 'country' },
  { value: 'CN', name: 'China', info: 'country' },
  { value: 'CX', name: 'Christmas Island', info: 'country' },
  { value: 'CC', name: 'Cocos (Keeling) Islands', info: 'country' },
  { value: 'CO', name: 'Colombia', info: 'country' },
  { value: 'KM', name: 'Comoros', info: 'country' },
  { value: 'CG', name: 'Congo (Brazzaville)', info: 'country' },
  { value: 'CD', name: 'Congo (Kinshasa)', info: 'country' },
  { value: 'CK', name: 'Cook Islands', info: 'country' },
  { value: 'CR', name: 'Costa Rica', info: 'country' },
  { value: 'CI', name: 'Cote D\'Ivoire', info: 'country' },
  { value: 'HR', name: 'Croatia', info: 'country' },
  { value: 'CU', name: 'Cuba', info: 'country' },
  { value: 'CY', name: 'Cyprus', info: 'country' },
  { value: 'CZ', name: 'Czech Republic', info: 'country' },
  { value: 'DK', name: 'Denmark', info: 'country' },
  { value: 'DJ', name: 'Djibouti', info: 'country' },
  { value: 'DM', name: 'Dominica', info: 'country' },
  { value: 'DO', name: 'Dominican Republic', info: 'country' },
  { value: 'TL', name: 'East Timor', info: 'country' },
  { value: 'EC', name: 'Ecuador', info: 'country' },
  { value: 'EG', name: 'Egypt', info: 'country' },
  { value: 'SV', name: 'El Salvador', info: 'country' },
  { value: 'GQ', name: 'Equatorial Guinea', info: 'country' },
  { value: 'ER', name: 'Eritrea', info: 'country' },
  { value: 'EE', name: 'Estonia', info: 'country' },
  { value: 'ET', name: 'Ethiopia', info: 'country' },
  { value: 'FK', name: 'Falkland Islands (Islas Malvinas)', info: 'country' },
  { value: 'FO', name: 'Faroe Islands', info: 'country' },
  { value: 'FJ', name: 'Fiji', info: 'country' },
  { value: 'FI', name: 'Finland', info: 'country' },
  { value: 'FR', name: 'France', info: 'country' },
  { value: 'GF', name: 'French Guiana', info: 'country' },
  { value: 'PF', name: 'French Polynesia', info: 'country' },
  { value: 'TF', name: 'French Southern and Antarctic Lands', info: 'country' },
  { value: 'GA', name: 'Gabon', info: 'country' },
  { value: 'GE', name: 'Georgia', info: 'country' },
  { value: 'DE', name: 'Germany', info: 'country' },
  { value: 'GH', name: 'Ghana', info: 'country' },
  { value: 'GI', name: 'Gibraltar', info: 'country' },
  { value: 'GR', name: 'Greece', info: 'country' },
  { value: 'GL', name: 'Greenland', info: 'country' },
  { value: 'GD', name: 'Grenada', info: 'country' },
  { value: 'GP', name: 'Guadeloupe', info: 'country' },
  { value: 'GT', name: 'Guatemala', info: 'country' },
  { value: 'GG', name: 'Guernsey', info: 'country' },
  { value: 'GN', name: 'Guinea', info: 'country' },
  { value: 'GW', name: 'Guinea-Bissau', info: 'country' },
  { value: 'GY', name: 'Guyana', info: 'country' },
  { value: 'HT', name: 'Haiti', info: 'country' },
  { value: 'HM', name: 'Heard Island and McDonald Islands', info: 'country' },
  { value: 'VA', name: 'Holy See (Vatican City)', info: 'country' },
  { value: 'HN', name: 'Honduras', info: 'country' },
  { value: 'HK', name: 'Hong Kong', info: 'country' },
  { value: 'HU', name: 'Hungary', info: 'country' },
  { value: 'IS', name: 'Iceland', info: 'country' },
  { value: 'IN', name: 'India', info: 'country' },
  { value: 'ID', name: 'Indonesia', info: 'country' },
  { value: 'IR', name: 'Iran', info: 'country' },
  { value: 'IQ', name: 'Iraq', info: 'country' },
  { value: 'IE', name: 'Ireland', info: 'country' },
  { value: 'IM', name: 'Isle of Man', info: 'country' },
  { value: 'IL', name: 'Israel', info: 'country' },
  { value: 'IT', name: 'Italy', info: 'country' },
  { value: 'JM', name: 'Jamaica', info: 'country' },
  { value: 'SJ', name: 'Jan Mayen', info: 'country' },
  { value: 'JP', name: 'Japan', info: 'country' },
  { value: 'JE', name: 'Jersey', info: 'country' },
  { value: 'JO', name: 'Jordan', info: 'country' },
  { value: 'KZ', name: 'Kazakhstan', info: 'country' },
  { value: 'KE', name: 'Kenya', info: 'country' },
  { value: 'KI', name: 'Kiribati', info: 'country' },
  { value: 'KW', name: 'Kuwait', info: 'country' },
  { value: 'KG', name: 'Kyrgyzstan', info: 'country' },
  { value: 'LA', name: 'Laos', info: 'country' },
  { value: 'LV', name: 'Latvia', info: 'country' },
  { value: 'LB', name: 'Lebanon', info: 'country' },
  { value: 'LS', name: 'Lesotho', info: 'country' },
  { value: 'LR', name: 'Liberia', info: 'country' },
  { value: 'LY', name: 'Libya', info: 'country' },
  { value: 'LI', name: 'Liechtenstein', info: 'country' },
  { value: 'LT', name: 'Lithuania', info: 'country' },
  { value: 'LU', name: 'Luxembourg', info: 'country' },
  { value: 'MO', name: 'Macau', info: 'country' },
  { value: 'MK', name: 'Macedonia', info: 'country' },
  { value: 'MG', name: 'Madagascar', info: 'country' },
  { value: 'MW', name: 'Malawi', info: 'country' },
  { value: 'MY', name: 'Malaysia', info: 'country' },
  { value: 'MV', name: 'Maldives', info: 'country' },
  { value: 'ML', name: 'Mali', info: 'country' },
  { value: 'MT', name: 'Malta', info: 'country' },
  { value: 'MQ', name: 'Martinique', info: 'country' },
  { value: 'MR', name: 'Mauritania', info: 'country' },
  { value: 'MU', name: 'Mauritius', info: 'country' },
  { value: 'YT', name: 'Mayotte', info: 'country' },
  { value: 'MX', name: 'Mexico', info: 'country' },
  { value: 'FM', name: 'Micronesia,Federated States of', info: 'country' },
  { value: 'MD', name: 'Moldova', info: 'country' },
  { value: 'MC', name: 'Monaco', info: 'country' },
  { value: 'MN', name: 'Mongolia', info: 'country' },
  { value: 'ME', name: 'Montenegro', info: 'country' },
  { value: 'MS', name: 'Montserrat', info: 'country' },
  { value: 'MA', name: 'Morocco', info: 'country' },
  { value: 'MZ', name: 'Mozambique', info: 'country' },
  { value: 'MM', name: 'Myanmar (Burma)', info: 'country' },
  { value: 'NA', name: 'Namibia', info: 'country' },
  { value: 'NR', name: 'Nauru', info: 'country' },
  { value: 'NP', name: 'Nepal', info: 'country' },
  { value: 'NL', name: 'Netherlands', info: 'country' },
  { value: 'AN', name: 'Netherlands Antilles', info: 'country' },
  { value: 'NC', name: 'New Caledonia', info: 'country' },
  { value: 'NZ', name: 'New Zealand', info: 'country' },
  { value: 'NI', name: 'Nicaragua', info: 'country' },
  { value: 'NE', name: 'Niger', info: 'country' },
  { value: 'NG', name: 'Nigeria', info: 'country' },
  { value: 'NU', name: 'Niue', info: 'country' },
  { value: 'NF', name: 'Norfolk Island', info: 'country' },
  { value: 'KP', name: 'North Korea', info: 'country' },
  { value: 'NO', name: 'Norway', info: 'country' },
  { value: 'OM', name: 'Oman', info: 'country' },
  { value: 'PK', name: 'Pakistan', info: 'country' },
  { value: 'PW', name: 'Paluau', info: 'country' },
  { value: 'PA', name: 'Panama', info: 'country' },
  { value: 'PG', name: 'Papua New Guinea', info: 'country' },
  { value: 'PY', name: 'Paraguay', info: 'country' },
  { value: 'PE', name: 'Peru', info: 'country' },
  { value: 'PH', name: 'Philippines', info: 'country' },
  { value: 'PN', name: 'Pitcairn Islands', info: 'country' },
  { value: 'PL', name: 'Poland', info: 'country' },
  { value: 'PT', name: 'Portugal', info: 'country' },
  { value: 'QA', name: 'Qatar', info: 'country' },
  { value: 'RE', name: 'Reunion', info: 'country' },
  { value: 'RO', name: 'Romania', info: 'country' },
  { value: 'RU', name: 'Russia', info: 'country' },
  { value: 'RW', name: 'Rwanda', info: 'country' },
  { value: 'SH', name: 'Saint Helena', info: 'country' },
  { value: 'KN', name: 'Saint Kitts and Nevis', info: 'country' },
  { value: 'LC', name: 'Saint Lucia', info: 'country' },
  { value: 'PM', name: 'Saint Pierre and Miquelon', info: 'country' },
  { value: 'VC', name: 'Saint Vincent and the Grenadines', info: 'country' },
  { value: 'WS', name: 'Samoa', info: 'country' },
  { value: 'SM', name: 'San Marino', info: 'country' },
  { value: 'ST', name: 'Sao Tome and Principe', info: 'country' },
  { value: 'SA', name: 'Saudi Arabia', info: 'country' },
  { value: 'SN', name: 'Senegal', info: 'country' },
  { value: 'RS', name: 'Serbia', info: 'country' },
  { value: 'SC', name: 'Seychelles', info: 'country' },
  { value: 'SL', name: 'Sierra Leone', info: 'country' },
  { value: 'SG', name: 'Singapore', info: 'country' },
  { value: 'SK', name: 'Slovakia', info: 'country' },
  { value: 'SI', name: 'Slovenia', info: 'country' },
  { value: 'SB', name: 'Solomon Islands', info: 'country' },
  { value: 'SO', name: 'Somalia', info: 'country' },
  { value: 'ZA', name: 'South Africa', info: 'country' },
  {
    value: 'GS',
    name: 'South Georgia and the South Sandwich Islands',
    info: 'country'
  },
  { value: 'KR', name: 'South Korea', info: 'country' },
  { value: 'ES', name: 'Spain', info: 'country' },
  { value: 'LK', name: 'Sri Lanka', info: 'country' },
  { value: 'SD', name: 'Sudan', info: 'country' },
  { value: 'SR', name: 'Suriname', info: 'country' },
  { value: 'SJ', name: 'Svalbard', info: 'country' },
  { value: 'SZ', name: 'Swaziland', info: 'country' },
  { value: 'SE', name: 'Sweden', info: 'country' },
  { value: 'CH', name: 'Switzerland', info: 'country' },
  { value: 'SY', name: 'Syria', info: 'country' },
  { value: 'TW', name: 'Taiwan', info: 'country' },
  { value: 'TJ', name: 'Tajikistan', info: 'country' },
  { value: 'TZ', name: 'Tanzania', info: 'country' },
  { value: 'TH', name: 'Thailand', info: 'country' },
  { value: 'BS', name: 'The Bahamas', info: 'country' },
  { value: 'GM', name: 'The Gambia', info: 'country' },
  { value: 'TG', name: 'Togo', info: 'country' },
  { value: 'TK', name: 'Tokelau', info: 'country' },
  { value: 'TO', name: 'Tonga', info: 'country' },
  { value: 'TT', name: 'Trinidad and Tobago', info: 'country' },
  { value: 'TN', name: 'Tunisia', info: 'country' },
  { value: 'TR', name: 'Turkey', info: 'country' },
  { value: 'TM', name: 'Turkmenistan', info: 'country' },
  { value: 'TC', name: 'Turks and Caicos Islands', info: 'country' },
  { value: 'TV', name: 'Tuvalu', info: 'country' },
  { value: 'UG', name: 'Uganda', info: 'country' },
  { value: 'UA', name: 'Ukraine', info: 'country' },
  { value: 'AE', name: 'United Arab Emirates', info: 'country' },
  { value: 'GB', name: 'United Kingdom', info: 'country' },
  { value: 'UY', name: 'Uruguay', info: 'country' },
  { value: 'UZ', name: 'Uzbekistan', info: 'country' },
  { value: 'VU', name: 'Vanuatu', info: 'country' },
  { value: 'VE', name: 'Venezuela', info: 'country' },
  { value: 'VN', name: 'Vietnam', info: 'country' },
  { value: 'WF', name: 'Wallis and Futuna', info: 'country' },
  { value: 'EH', name: 'Western Sahara', info: 'country' },
  { value: 'YE', name: 'Yemen', info: 'country' },
  { value: 'ZM', name: 'Zambia', info: 'country' },
  { value: 'ZW', name: 'Zimbabwe', info: 'country' }
];



// WEBPACK FOOTER //
// ./src/utils/countryCodes.js